<template>
  <div
    class="w-full relative header-bg-color header-text-color membership-site-header z-11
    "
    :style="[customCss]"
  >
    <div class="membership-layout-container">
      <div class="flex justify-between items-center py-5">
        <slot name="logo"></slot>
        <div
          class="flex flex-1 header-bg-color header-text-color flex-wrap justify-end items-center pl-3 text-base text-white capitalize menu"
        >
          <slot name="menus" class="header-bg-color header-text-color" :style="[customCss]"></slot>
          <div
            class="h-full flex items-center right-0 top-0 mr-0 static profile-wrapper"
          >
            <slot name="profile"></slot>
            <slot name="button"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    getThemeSettings: {
      type: Function,
      required: true,
    },
  },
  computed: {
    customCss() {
      return {
        '--template-header-bg-color': this.themeSettings.navbar_section
          .bg_color,
        '--template-header-text-color': this.themeSettings.navbar_section
          .text_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
};
</script>
<style lang="scss" scoped>
.header-bg-color {
  background-color: var(--template-header-bg-color);
}
.header-text-color {
  color: var(--template-header-text-color);
}
.profile-wrapper {
  // position:absolute;
  @media only screen and (max-width: 1250px) {
    position: relative;
  }
}
@media only screen and (max-width:991px){
  .membership-site-header{
    z-index: 13;
  }
}
</style>
